import React from 'react';

interface CustomSubTitleProps {
  subtitle?: string | null;
  subTitleStyle?: {
    fontSize?: string;
    color?: string;
    alignment?: string;
    alignmentClass?: string; // For pre-calculated alignment classes
    [key: string]: any; // Allow other styling properties
  } | null;
  className?: string; // Additional classes to apply
}

const CustomSubTitle = ({
  subtitle,
  subTitleStyle,
  className = '',
}: CustomSubTitleProps) => {
  const getSubtitleFontSize = () => {
    if (!subTitleStyle?.fontSize) return 'text-sm sm:text-base lg:text-lg';

    switch (subTitleStyle.fontSize) {
      case 'xs':
        return 'text-xs sm:text-xs lg:text-base';
      case 'sm':
        return 'text-xs sm:text-sm lg:text-base';
      case 'md':
        return 'text-sm sm:text-base lg:text-lg';
      case 'lg':
        return 'text-lg sm:text-lg lg:text-xl';
      case 'xl':
        return 'text-xl sm:text-lg lg:text-2xl';
      case '2xl':
        return 'text-2xl sm:text-lg lg:text-3xl';
      case '3xl':
        return 'text-3xl sm:text-2xl lg:text-4xl';
      case '4xl':
        return 'text-4xl sm:text-3xl lg:text-5xl';
      case '5xl':
        return 'text-5xl sm:text-4xl lg:text-5xl';
      default:
        return 'text-sm sm:text-base lg:text-lg';
    }
  };

  const inlineStyle: React.CSSProperties = {
    color: subTitleStyle?.color || '#fff',
  };
  if (subTitleStyle?.fontSize && subTitleStyle?.fontSize?.includes('px')) {
    // fontSize is specifically set, not a tailwind class
    inlineStyle.fontSize = subTitleStyle.fontSize;
  }

  if (subTitleStyle) {
    Object.keys(subTitleStyle).forEach((key) => {
      // Skip properties we've already handled or that should be in className
      if (!['fontSize', 'color', 'alignment', 'alignmentClass'].includes(key)) {
        // Use the key as-is (camelCase) for React inline styles
        inlineStyle[key] = subTitleStyle[key];
      }
    });
  }

  const alignmentClass = subTitleStyle?.alignmentClass || 'text-center';

  return (
    <p
      className={`mt-1.5 lg:mt-2 ${getSubtitleFontSize()} w-full ${alignmentClass} ${className}`}
      style={inlineStyle}
    >
      {subtitle}
    </p>
  );
};

export default CustomSubTitle;
